// src/app/core/services/otp-session.service.ts
import { Injectable } from '@angular/core';
import { DeviceIdService } from './device-id.service';

export interface OtpSession {
  sessionToken: string;
  expiresAt: number;
}

@Injectable({ providedIn: 'root' })
export class OtpSessionService {
  private readonly PREFIX = 'otp_session_';

  constructor(private deviceIdService: DeviceIdService) {}

  private storageKey(feature: string): string {
    return `${this.PREFIX}${feature}`;
  }

  saveLocalSession(feature: string, session: OtpSession): void {
    localStorage.setItem(this.storageKey(feature), JSON.stringify(session));
  }

  getLocalSession(feature: string): OtpSession | null {
    const raw = localStorage.getItem(this.storageKey(feature));
    if (!raw) return null;

    try {
      const session: OtpSession = JSON.parse(raw);
      if (!session.sessionToken || !session.expiresAt) return null;
      if (Date.now() > session.expiresAt) {
        this.clearSession(feature);
        return null;
      }
      return session;
    } catch {
      return null;
    }
  }

  hasValidSession(feature: string): boolean {
    return this.getLocalSession(feature) !== null;
  }

  clearSession(feature: string): void {
    localStorage.removeItem(this.storageKey(feature));
  }

  getDeviceId(): string {
    return this.deviceIdService.getDeviceId();
  }
}